import "@nested/polyfills";

require("./browserRender");
